<template>
  <span
    data-cy="custom-form-status-chip"
    :class="[
      'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
      chip.class
    ]"
  >
    {{ chip.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

type Status = "published" | "draft" | "archived";

const props = defineProps<{ status: Status | string }>();

const CHIPS: Record<Status, { label: string; class: string }> = {
  published: { label: "Published", class: "bg-green-100 text-green-800" },
  draft: { label: "Draft", class: "bg-amber-100 text-amber-800" },
  archived: { label: "Archived", class: "bg-gray-100 text-gray-600" }
};

const chip = computed(() => CHIPS[props.status as Status] ?? CHIPS.draft);
</script>
